import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import UI_Challenge from "../../ui/Main/UI_Challenge";
import { CustomConfig } from "../config/CustomConfig";
import LTPlatform from "../../LTGame/Platform/LTPlatform";
import GlobalUnit from "../common/GlobalUnit";
import AudioManager from "../manager/AudioManager";
export class UI_ChallengeMediator extends BaseUIMediator {
    get ui() {
        return this._ui;
    }
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_ChallengeMediator();
            this._instance._classDefine = UI_Challenge;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        var mode = this._openParam;
        this.cacheList = CustomConfig.dataList.filter(e => {
            return e.level_type == mode;
        });
        this.ui.m_btn_close.onClick(this, this._OnClickClose);
        this.ui.m_list_lv.setVirtual();
        this.ui.m_list_lv.itemRenderer = Laya.Handler.create(this, this._OnRenderItem, null, false);
        this.ui.m_list_lv.on(fgui.Events.CLICK_ITEM, this, this._OnClickItem);
        this.ui.m_list_lv.numItems = this.cacheList.length;
        this.ui.m_title_loader.url = this.cacheList[0].title_path;
    }
    _OnClickClose() {
        this.Hide();
    }
    _OnRenderItem(index, item) {
        var data = this.cacheList[index];
        item.m_icon.url = data.icon_path;
        item.m_txt_name.text = data.level_name;
        item.data = index;
        item.m_btn_start.m_ad.selectedIndex = GlobalUnit.dataManager.IsLevelUnlocked(data.level_id) ? 0 : 1;
    }
    _OnClickItem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            var index = parseInt(item.data.toString());
            var data = this.cacheList[index];
            var unlocked = GlobalUnit.dataManager.IsLevelUnlocked(data.level_id);
            if (!unlocked) {
                unlocked = yield LTPlatform.instance.ShowRewardVideoAdAsync();
            }
            if (unlocked) {
                GlobalUnit.dataManager.UnlockLevel(data.level_id);
                this.Hide();
                // UI_SuperMediator.instance.Show(() => {
                yield GlobalUnit.game.startChallengeLevel(data.level_id, data.default_skin_id);
                AudioManager.instance.PlayById(data.bgm_id);
                // });
            }
        });
    }
    _OnHide() { }
}
